
    // **BEGIN** Hextom TMS Integration - DO NOT MODIFY
      var hextom_tms = {
        selectorInsertType:  "float",
        regionType:  "region_name_currency_symbol",
        floatingPosition: "bottom_left",
        floatingPaddingHorizontal:  15,
        floatingPaddingVertical:  15,
        availableLocalesById: {},
        availableLocales: [],
        primaryLocaleById: {},
        merchantSelectedLocale: "shop_base",
        hasFlag: "yes",
        selectorFlagMap: {'en': 'en', 'fr': 'fr', 'de': 'de'},
        displayType: "language_code",
        fontColor: "#000000",
        backgroundColor: "#FFFFFF",
        backgroundOpacity: "1.0",
        buttonFontColor: "#FFFFFF",
        buttonBackgroundColor: "#000000",
        selectorType: "market_language",
        selectorStyle: "dropdown",
        hasFlagRegion: "yes",    
        defaultRegion: "JP",    
        primaryRegionById: {},    
        availableRegionsByCode: {},    
        availableRegions: [],
        primaryDomain: "",
        popupEnable: false,
        popupTextColor: "#000000",
        popupBgColor: "#FFFFFF",
        popupBtnTextColor: "#FFFFFF",
        popupBtnBgColor: "#000000",
        regions: [{"name": "Japan", "code": "JP", "currency": {"code": "JPY", "symbol": "\u00a5"}, "languages": {"Fran\u00e7ais": {"name": "Fran\u00e7ais (French)", "native_name": "Fran\u00e7ais", "code": "fr", "default": true}, "English": {"name": "English", "native_name": "English", "code": "en", "default": false}, "Deutsch": {"name": "Deutsch (German)", "native_name": "Deutsch", "code": "de", "default": false}}, "primary": true}],
      };
    // **END** Hextom TMS Integration - DO NOT MODIFY
    